export enum NotificationTarget {
  SINGLE_USER = 'SINGLE_USER',
  TOPIC_BASED = 'TOPIC_BASED',
  GROUP = 'GROUP',
  BROADCAST = 'BROADCAST',
}

export type messageType = {
  title: string;
  body?: string;
  data?: {
    id: string;
    notificationId?: number | null;
  };
  id: string | number;
  businessId: number;
};
